import request from '../utils/request'

export function dayloglist(data) {
    return request({
    url: '/api/dayloglist',
    method: 'post',
    data
    })
}


export function GetDataFlow(params) {
    return request({
    url: '/api/daycalc',
    method: 'get',
    params 
    })
}


export function clientConfigList(data) {
    return request({
    url: '/api/clientconfigs',
    method: 'get',
    data
    })
}

export function addClientConfig(data) {
    return request({
    url: '/api/clientconfig',
    method: 'post',
    data
    })
}

export function updateClientConfig(data) {
    return request({
    url: '/api/clientconfig',
    method: 'put',
    data
    })
}

export function DelClientConfig(data) {
    return request({
    url: '/api/clientconfig',
    method: 'delete',
    data
    })
}

export function GroupList(data) {
    return request({
    url: '/api/groups',
    method: 'get',
    data
    })
}

export function AddGroup(data) {
    return request({
    url: '/api/groups',
    method: 'post',
    data
    })
}

export function UpdateGroup(name, data) {
    return request({
        url: `/api/groups/${name}`,  // 将参数插入到路径中
        method: 'put',              // 对应PUT方法
        data                        // 请求体数据
    })
}

export function DelGroup(data) {
    return request({
    url: '/api/groups',
    method: 'delete',
    data
    })
}

export function GetProducts(params) {
    return request({
    url: '/api/products',
    method: 'get',
    params
    })
}

export function GetProduct(name,data) {
    return request({
    url: `/api/products/${name}`,
    method: 'get',
    data
    })
}

export function AddProduct(data) {
    return request({
    url: '/api/products',
    method: 'post',
    data
    })
}

export function UpdateProduct(name,data) {
    return request({
    url: `/api/products/${name}`,
    method: 'put',
    data
    })
}

export function SetProductIsOff(name,data) {
    return request({
    url: `/api/products/${name}/isoff`,
    method: 'put',
    data
    })
}

export function SetProductDesc(name,data) {
    return request({
    url: `/api/products/${name}/desc`,
    method: 'put',
    data
    })
}

export function GetProductTips(name,data) {
    return request({
    url: `/api/products/${name}/tips`,
    method: 'get',
    data
    })
}

export function DelProduct(data) {
    return request({
    url: '/api/products',
    method: 'delete',
    data
    })
}

export function GetProductTemps(data) {
    return request({
    url: '/api/producttemps',
    method: 'get',
    data
    })
}

export function ParseProductTemp(data) {
    return request({
    url: '/api/parseproducttemp',
    method: 'post',
    data
    })
}

export function AddProductByTemp(data) {
    return request({
    url: '/api/producttemps',
    method: 'post',
    data
    })
}

export function GetCallTransfromLimit(data) {
    return request({
    url: '/api/configs/calltransformlimit',
    method: 'get',
    data
    })
}


export function AddCallTransfromLimit(key,data) {
    return request({
    url: `/api/configs/calltransformlimit/${key}`,
    method: 'post',
    data
    })
}

export function UpdateCallTransfromLimit(key,data) {
    return request({
    url: `/api/configs/calltransformlimit/${key}`,
    method: 'put',
    data
    })
}

export function DelCallTransfromLimit(key,data) {
    return request({
    url: `/api/configs/calltransformlimit/${key}`,
    method: 'delete',
    data
    })
}


export function GetDayLogs(params) {
    return request({
    url: '/api/daylogs',
    method: 'get',
    params
    })
}


export function GetCallbackInfo(params) {
    return request({
    url: '/api/callbackinfo',
    method: 'get',
    params
    })
}

// ==================== 计划任务相关接口 ====================

// 获取计划任务列表
export function GetScheduleTasks(groupName) {
    return request({
        url: `/api/groupplans/${groupName}`,
        method: 'get'
    })
}

// 保存计划任务（全量更新）
export function SaveScheduleTasks(groupName, data) {
    return request({
        url: `/api/groupplans/${groupName}`,
        method: 'put',
        data
    })
}

// 获取计划任务执行状态详情
export function GetGroupPlanDetails(groupName) {
    return request({
        url: `/api/groupplandetails`,
        method: 'get',
        params: { group: groupName }
    })
}
